<template>
  <el-form 
    ref="form"
    :size="size"
    :label-suffix="labelSuffix"
    :inline="inline"
    :label-position="labelPosition"
    v-on="$listeners"
    :model="formModel"
    v-bind="$attrs"
    @submit.native.prevent>

      <el-form-item
       v-for="(item,index) in formData"
        v-show="showAll?true:!item.advanced" 
        :label="item.notTranslate?item.label:t(item.label)"
        :key="index"
        :prop="item.prop"
        v-bind="item.formItemProps">
       
        <el-select
          v-if="item.type == 'select'"
          v-model="item.value" 
          v-bind="item.elProps || {}"
          v-on="$listeners"
           :placeholder="item.elProps && item.elProps.rawPlaceholder?item.elProps.rawPlaceholder:(item.elProps&&item.elProps.placeholder? t(item.elProps.placeholder) : '')"
          @change="handleChange($event, item)">

          <el-option
            v-for="(addOp,index) in item.additionalOptions|| []"
            :key="'addOp'+index"
            :label="t(addOp.label)"
            :disabled="addOp.disabled"
            :value="addOp.value">
          </el-option>
          <el-option
            v-for="(op,index) in item.options"
            :key="'op'+index"
            :label="item.optionNotTranslate?op.label:t(op.label)"
            :disabled="item.disabled"
            :value="op.value">
          </el-option>
        </el-select>

        <el-time-select
          v-else-if="item.type == 'time-select'"
          v-model="item.value" 
          v-bind="item.elProps"
          @change="handleChange($event, item)"
           :placeholder="item.elProps && item.elProps.rawPlaceholder?item.elProps.rawPlaceholder:(item.elProps&&item.elProps.placeholder? t(item.elProps.placeholder) : '')">
        </el-time-select>

        <el-time-picker
          v-else-if="item.type == 'time-picker'"
          v-model="item.value" 
          v-bind="item.elProps"
          @change="handleChange($event, item)"
           :placeholder="item.elProps && item.elProps.rawPlaceholder?item.elProps.rawPlaceholder:(item.elProps&&item.elProps.placeholder? t(item.elProps.placeholder) : '')">
        </el-time-picker>

        <el-date-picker
          v-else-if="item.type == 'date-picker'"
          v-model="item.value" 
          v-bind="item.elProps"
          @change="handleChange($event, item)"
           :placeholder="item.elProps && item.elProps.rawPlaceholder?item.elProps.rawPlaceholder:(item.elProps&&item.elProps.placeholder? t(item.elProps.placeholder) : '')">
        </el-date-picker>

        <el-cascader
          v-else-if="item.type == 'cascader'"
          v-model="item.value" 
          v-bind="item.elProps"
          :options="item.options?item.options:[]"
          @change="handleChange($event, item)">
        </el-cascader>
        
        <el-input-number 
         v-else-if="item.type == 'number'"
         v-model="item.value" 
         v-bind="item.elProps"
         :placeholder="item.elProps && item.elProps.rawPlaceholder?item.elProps.rawPlaceholder:(item.elProps&&item.elProps.placeholder? t(item.elProps.placeholder) : '')">
        </el-input-number>

        <el-switch
         v-else-if="item.type == 'switch'"
         v-model="item.value" 
         v-bind="item.elProps"
         @change="handleChange($event, item)">
        </el-switch>

        <el-upload 
          v-else-if="item.type == 'file'"
          v-bind="item"
          action="" 
          :show-file-list="false"
          :on-change="(file) => handlefileChange(file,item)"
          :auto-upload="false">
            <el-input
              v-model="item.value" 
              slot=""
              readonly>
                <el-button slot="append" icon="el-icon-folder"></el-button>
            </el-input>
        </el-upload>

        <el-radio-group 
        v-else-if="item.type == 'radio-group'"
        @change="handleChange($event, item)"
        v-bind="item.elProps"
        v-model="item.value" >
            <el-radio v-for="(radio,index) in item.additionalOptions|| []" :key="'add'+index" :label="radio.value">{{radio.label}}</el-radio>
            <el-radio v-for="(radio,index) in item.options" :key="index" :label="radio.value">{{item.optionNotTranslate?radio.label:t(radio.label)}}</el-radio>
        </el-radio-group>

        <el-checkbox-group
          v-else-if="item.type == 'checkbox'"
          v-bind="item.elProps"
          v-model="item.value" 
          @change="handleChange($event, item)"
        >
          <el-checkbox 
          v-for="(check, index) in item.additionalOptions || []" 
          :label="check.value" 
          :key="'add'+index">{{check.label}}</el-checkbox>
          <el-checkbox 
          v-for="(check, index) in item.options" 
          :label="check.value" 
          :key="index">{{item.optionNotTranslate ? check.label : t(check.label) }}</el-checkbox>
        </el-checkbox-group>

        <hs-tree-select
        v-else-if="item.type == 'tree-select'"
        v-bind="item.elProps"
        v-model="item.value" 
        @change="handleChange($event, item)"
        ></hs-tree-select>
        <hs-number-input
        v-else-if="item.type == 'number-input'"
        v-bind="item.elProps"
        v-model="item.value" 
        @change="handleChange($event, item)"
        ></hs-number-input>

        <component v-else-if="item.type == 'components'" :is="item.component" v-model="item.value" v-bind="item.elProps" @change="handleChange($event, item)"></component>

        <el-input 
          v-else
          v-model="item.value" 
          v-bind="item.elProps"
          :placeholder="item.elProps && item.elProps.rawPlaceholder?item.elProps.rawPlaceholder:(item.elProps&&item.elProps.placeholder? t(item.elProps.placeholder) : '')"
          @change="handleChange($event, item)"
          @clear="item.clear?item.clear($event) : ''"
          @blur="item.blur?item.blur($event) : ''"
          @focus="item.focus?item.focus($event) : ''"
          @input="item.input?item.input($event) : ''"
          @keyup.enter.native="formSearch">
            <span v-for="(v,k) in item.slots" :slot="k" :key="k">
              {{ v }}
            </span>
        </el-input>
      </el-form-item>
    <slot />
  </el-form>
</template>

<script>
import HsTreeSelect from '../treeSelect'
import HsNumberInput from '../numberInput'

import Locale from '../../mixins/locale';

export default {
  name: 'HsForm',
  components: {
    HsNumberInput,
    HsTreeSelect
  },
  mixins: [Locale],
    
  props: {
    /**表单元素大小 */
    size: {
      type: String,
      default: '',
      // validator: function (value) {
      //   return ['small', 'medium','mini'].indexOf(value) !== -1;
      // },
    },
    /**label显示位置 */
    labelPosition: {
      type: String,
      default: 'top',
      validator: function (value) {
        return ['right', 'left', 'top'].indexOf(value) !== -1;
      },
    },
    /**是否内联显示 */
    inline: {
      type: Boolean,
      default: false
    },
    /** 表单label后缀 */
    labelSuffix: {
      type: String,
      default: ': '
    },
    /** 表单绑定数组对象 */
    formData: {
      type: Array,
      default(){
        return []
      }
    },
    /** 是否显示全部内容 */
    showAll: {
      type: Boolean,
      default: true
    },
    /** change事件是否调用默认搜索方法(searchbar使用) */
    useDefaultChange: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    formData: {
      handler(value) {
        let newFormModel = {};
        value.forEach(item => {
          newFormModel[item.prop] = item.value;
        })
        this.formModel = newFormModel;
      },
      deep: true,
      immediate: true,
    }
  },
  data() {
    return {
      formModel: {},
      files: {}
    };
  },
  methods: {
    formSearch() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$emit('search', this.formModel);
        }
      });
    },

    resetForm(){
      if (this.$refs.form) {
        this.$refs.form.resetFields();
        const _model = { ...this.formModel };
        this.formData.forEach(item => {
          if (item.type == 'time-picker' && item.elProps['is-range']) {
            item.value = '';
          } else {
            item.value = _model[item.prop];
          }
        })
      }
    },

    validate( callback) {
      this.$refs.form.validate( valid => callback(valid))
    },

    handleChange(e, item) {
      this.formModel[item.prop] = item.value
      item.change ? item.change(e) : (this.useDefaultChange ? this.formSearch():'')
    },

    handlefileChange(file, item) {
      item.value = file.name
      this.files[item.prop] = file
      this.formModel[item.prop] = file.name
      item.change ? item.change(e) : (this.useDefaultChange ? this.formSearch():'')
    },

    getFormModel() {
      let newFormModel = {};
      this.formData.forEach(item => {
        newFormModel[item.prop] = item.value;
      })
      return Object.assign({}, newFormModel, this.files);
    }
  }
}
</script>